import serviceProvider from "../../services/provider/ProviderService";
import serviceCalendar from "../../services/calendar/serviceCalendar";
import branchService from "../../services/branch/BranchService";
import dayjs from "dayjs";
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");

export default {
  data: () => ({
    providersList: [],
    providers: [],
    branchesList: [],
    branches: [],
    loading: false,
    holiday: [],
    itemRules: [(v) => !!v || "Item is required"],
    daysOfWeek: [],
    calendarseled: "",
    calendarSelect: [
      {
        id: 0,
        name: "POS",
      },
      {
        id: 1,
        name: "Consentido",
      },
      {
        id: 2,
        name: "Póliza",
      },
    ],
    daysOfWeekList: [
      {
        id: 0,
        name: "Domingo",
      },
      {
        id: 1,
        name: "Lunes",
      },
      {
        id: 2,
        name: "Martes",
      },
      {
        id: 3,
        name: "Miércoles",
      },
      {
        id: 4,
        name: "Jueves",
      },
      {
        id: 5,
        name: "Viernes",
      },
      {
        id: 6,
        name: "Sábado",
      },
    ],
    closingTime: null,
    menuClosingTime: false,
    menuInitialDate: false,
    minDate: "",
    initialDate: "",
    finalDate: "",
    loadingSave1: false,
    calendarseledEdit: "",
    providerEdit: "",
    branchEdit: "",
    providersListEdit: [],
    branchesListEdit: [],
    menuDateEdit: false,
    dateEdit: "",
    minDateEdit: "",
    idCaledar: "",
    closingTimeEdit: null,
    menuClosingTime2: false,
    loadingSave2: false,
    responseDaysEdit: "",
    activeDate: true,
    loadedDate: false,
    isSpoiled: false,
    isPoliza: false,
    isSpoiled2: false,
    isPolizaEdit: false,
  }),

  created() {
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isSameOrAfter);
    this.minDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.maxDate = dayjs().add(2, "year").format("YYYY-MM-DD");
    this.minDateEdit = dayjs(new Date()).format("YYYY-MM-DD");
  },
  methods: {
    cancel1() {
      this.calendarseled = "";
      this.branchesList = [];
      this.providersList = [];
      this.providers = "";
      this.branches = [];
      this.daysOfWeek = [];
      this.responseDays = "";
      this.closingTime = null;
      this.initialDate = "";
      this.finalDate = "";
    },
    cancel2() {
      this.calendarseledEdit = "";
      this.branchesListEdit = [];
      this.providersListEdit = [];
      this.providerEdit = "";
      this.branchEdit = [];
      this.dateEdit = "";
      this.loadedDate = false;
      this.activeDate = true;
      this.responseDaysEdit = "";
      this.closingTimeEdit = null;
    },
    async save1() {
      try {
        this.loadingSave1 = true;

        if (
          this.initialDate === "" ||
          this.initialDate === undefined ||
          this.initialDate === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar la fecha inicial",
          });
          this.loadingSave1 = false;
          return;
        }

        if (
          this.finalDate === "" ||
          this.finalDate === undefined ||
          this.finalDate === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar la fecha final",
          });
          this.loadingSave1 = false;
          return;
        }

        /* if (this.responseDays === '' || this.responseDays === undefined || this.responseDays === null) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe ingresar un número de días de respuesta"
          });
          this.loadingSave1 = false
          return
        }*/

        if (
          this.closingTime === "" ||
          this.closingTime === undefined ||
          this.closingTime === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe ingresar la hora de cierre",
          });
          this.loadingSave1 = false;
          return;
        }

        if (this.daysOfWeek.length === 0) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar al menos un día de la semana para configurar",
          });
          this.loadingSave1 = false;
          return;
        }

        if (this.branches.length === 0) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar al menos una sede para configurar",
          });
          this.loadingSave1 = false;
          return;
        }
        if (this.idCaledar == 0) {
          this.isSpoiled = false;
          this.isPoliza = false;
        } else if (this.idCaledar == 1) {
          this.isSpoiled = true;
          this.isPoliza = false;
        } else {
          this.isSpoiled = false;
          this.isPoliza = true;
        }

        const data = {
          initialDate: this.initialDate,
          finalDate: this.finalDate,
          responseDays: this.responseDays ? this.responseDays : 2,
          closingTime: this.closingTime,
          daysOfWeekSelected: this.daysOfWeek,
          branches: this.branches,
          spoiled: this.isSpoiled,
          poliza: this.isPoliza,
        };
        const response = await serviceCalendar.create(data);
        this.loadingSave1 = false;
        this.$notify({
          group: "app",
          type: "success",
          text: "Configuración guardada correctamente",
        });
        this.cancel1();
      } catch (error) {
        this.loadingSave1 = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "Error configurando el calendario",
        });
      }
    },
    async save2() {
      try {
        this.loadingSave2 = true;

        if (
          this.dateEdit === "" ||
          this.dateEdit === undefined ||
          this.dateEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar la fecha",
          });
          this.loadingSave2 = false;
          return;
        }

        if (
          this.responseDaysEdit === "" ||
          this.responseDaysEdit === undefined ||
          this.responseDaysEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe ingresar un número de días de respuesta",
          });
          this.loadingSave2 = false;
          return;
        }

        if (
          this.closingTimeEdit === "" ||
          this.closingTimeEdit === undefined ||
          this.closingTimeEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe ingresar la hora de cierre",
          });
          this.loadingSave2 = false;
          return;
        }

        if (this.activeDate === null || this.activeDate === undefined) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe indicar si el día esta habilitado",
          });
          this.loadingSave2 = false;
          return;
        }

        if (
          this.branchEdit === "" ||
          this.branchEdit === undefined ||
          this.branchEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar una sede para configurar",
          });
          this.loadingSave2 = false;
          return;
        }
        if (this.idCaledar == 0) {
          this.isSpoiled2 = false;
          this.isPolizaEdit = false;
        } else if (this.idCaledar == 1) {
          this.isSpoiled2 = true;
          this.isPolizaEdit = false;
        } else {
          this.isSpoiled2 = false;
          this.isPolizaEdit = true;
        }
        const data = {
          date: this.dateEdit,
          active: this.activeDate,
          responseDays: this.responseDaysEdit ? this.responseDaysEdit : 2,
          closingTime: this.closingTimeEdit,
          branch: this.branchEdit,
          spoiled: this.isSpoiled2,
          poliza: this.isPolizaEdit,
        };
        const response = await serviceCalendar.edit(data);
        this.loadingSave2 = false;
        this.$notify({
          group: "app",
          type: "success",
          text: "Configuración guardada correctamente",
        });
        this.cancel2();
      } catch (error) {
        this.loadingSave2 = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "Error configurando el calendario",
        });
      }
    },
    changeInitialDate() {
      let initialDate = dayjs(this.initialDate).format("YYYY-MM-DD");
      this.minDate = initialDate;
      if (
        (this.finalDate !== null) & (this.finalDate !== undefined) &&
        this.finalDate !== ""
      ) {
        if (!dayjs(this.finalDate).isSameOrAfter(initialDate)) {
          this.finalDate = this.minDate;
        }
      } else {
        this.finalDate = this.minDate;
      }
      this.maxDate = dayjs(this.initialDate)
        .add(2, "years")
        .format("YYYY-MM-DD");
    },
    async getProviders() {
      try {
        const response = await serviceProvider.getProviders();
        this.providersList = response.data;
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando los proveedores",
        });
      }
    },
    async getProvaiderscalendar(event) {
      this.idCaledar = event;
      this.providersList = [];
      this.providers = [];
      this.branchesList = [];
      this.branches = [];
      this.getProviders();
    },
    async getCalendar() {
      console.log("this.idCaledar", this.idCaledar);
      this.branchesList = [];
      this.branches = [];
      if (this.idCaledar != 2) {
        this.getBranches();
      } else {
        this.getCalendarBranch();
      }
    },
    async getCalendarBranch() {
      try {
        if (this.providers.length > 0) {
          const data = {
            providers: this.providers,
          };
          const response = await branchService.getByProvidersPolicy(data);
          this.branchesList = response.data;
        } else {
          this.branchesList = [];
        }
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando las sedes",
        });
      }
    },
    async getBranches() {
      try {
        if (this.providers.length > 0) {
          const data = {
            providers: this.providers,
          };
          const response = await branchService.getByProviders(data);
          this.branchesList = response.data;
        } else {
          this.branchesList = [];
        }
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando las sedes",
        });
      }
    },
    async getProvidersEdit() {
      try {
        const response = await serviceProvider.getProviders();
        this.providersListEdit = response.data;
        console.log(" this.providersListEdit", this.providersListEdit);
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando los proveedores",
        });
      }
    },
    async getBranchesEdit() {
      console.log("paso");
      try {
        if (this.providerEdit) {
          const data = {
            providers: [this.providerEdit],
          };
          const response = await branchService.getByProviders(data);
          this.branchesListEdit = response.data;
        } else {
          this.branchesListEdit = [];
        }
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando las sedes",
        });
      }
    },
    async getProvaiderscalendarEdit(event) {
      this.idCaledar = event;
      this.providersListEdit = [];
      this.providerEdit = [];
      this.branchesListEdit = [];
      this.branchesEdit = [];
      this.getProvidersEdit();
    },
    async getCalendarEdit() {
      console.log("this.idCaledar", this.idCaledar);
      this.branchesListEdit = [];
      this.branchesEdit = [];
      if (this.idCaledar != 2) {
        this.getBranchesEdit();
      } else {
        this.getCalendarBranchEdit();
      }
    },
    async getCalendarBranchEdit() {
      console.log("paso1");
      try {
        if (this.providerEdit) {
          const data = {
            providers: [this.providerEdit],
          };
          const response = await branchService.getByProvidersPolicy(data);
          this.branchesListEdit = response.data;
        } else {
          this.branchesListEdit = [];
        }
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando las sedes",
        });
      }
    },
    async getConfig() {
      try {
        if (
          this.dateEdit === "" ||
          this.dateEdit === undefined ||
          this.dateEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe selecionar una fecha",
          });
          return;
        }
        if (
          this.branchEdit === "" ||
          this.branchEdit === undefined ||
          this.branchEdit === null
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe seleccionar una sede",
          });
          return;
        }
        if (this.idCaledar == 0) {
          this.isSpoiled2 = false;
          this.isPolizaEdit = false;
        } else if (this.idCaledar == 1) {
          this.isSpoiled2 = true;
          this.isPolizaEdit = false;
        } else {
          this.isSpoiled2 = false;
          this.isPolizaEdit = true;
        }
        const data = {
          date: this.dateEdit,
          branch: this.branchEdit,
          spoiled: this.isSpoiled2,
          poliza: this.isPolizaEdit,
        };
        const response = await serviceCalendar.getCalendarConfiguration(data);
        this.closingTimeEdit = response.data.closingTime;
        this.activeDate = response.data.enabled;
        this.responseDaysEdit = response.data.responseDays;
        this.loadedDate = true;
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Error consultando la configuración",
        });
      }
    },
  },
};
